import { ReactNode } from 'react';
import { useAuth } from '../contexts/AuthContext';

export function AuthGuard({ children }: { children: ReactNode }) {
  const { operator } = useAuth();
  if (!operator) return null;
  return <>{children}</>;
}
